module.exports = __webpack_public_path__ + "img/chip-close.a2c39034.svg";